import { Directive, Input } from '@angular/core';
import {
  NG_VALIDATORS,
  FormControl,
  Validator,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';

import * as CardValidator from 'card-validator';

@Directive({
  selector: '[validCardDate][ngModel]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: JbCardDateValidator, multi: true}
  ]
})
export class JbCardDateValidator implements Validator {
  public validate(c: FormControl): ValidationErrors | any {
    const validation = CardValidator.expirationDate(c.value);

    return validation.isPotentiallyValid ? null : {
      validCardDate: {
        valid: false
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/form/validators/cardDate.validator.ts